// extracted by mini-css-extract-plugin
var _1 = "ProfileContactsWidgetLabel-modulewrapper__WXVmV";
export { _1 as "wrapper" }
